import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import permission from './modules/permission'
import warningRecord from './modules/warningRecord'
import customerUser from './modules/customerUser'
import webSocketUUID from './modules/webSocketUUID'
import getters from './getters'
import customerUserMeterInfo from '@/store/modules/customerUserMeterInfo'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    user,
    permission,
    customerUser,
    webSocketUUID,
    customerUserMeterInfo,
    warningRecord
  },
  getters
})

export default store
